import Layout from '@/layout'

const carBrandRouter = {
  path: '/car',
  component: Layout,
  name: 'car',
  meta: {
    title: '报价车型管理',
    icon: 'el-icon-truck',
    roles: ['root', 'market', 'business']
  },
  children: [
    {
      path: 'carbrand_ppf_list',
      name: 'CarBrandPPFTable',
      component: () => import('@/views/minip/car/carBrandPPFTable'),
      meta: { title: '车衣-车品牌列表', icon: 'el-icon-s-unfold', noCache: false }
    },
    {
      path: 'carmodel_ppf_list',
      name: 'CarModelPPFTable',
      component: () => import('@/views/minip/car/carModelPPFTable'),
      meta: { title: '车衣-车型号列表', icon: 'el-icon-s-fold', noCache: false }
    },
    {
      path: 'carbrand_wf_list',
      name: 'CarBrandTableWf',
      component: () => import('@/views/minip/car/carBrandWfTable'),
      meta: { title: '隔热膜-车品牌列表', icon: 'el-icon-s-unfold', noCache: false }
    },

    {
      path: 'carmodel_wf_list',
      name: 'CarModelTableWf',
      component: () => import('@/views/minip/car/carModelWfTable'),
      meta: { title: '隔热膜-车型号列表', icon: 'el-icon-s-fold', noCache: false }
    }
  ]
}
export default carBrandRouter
